import React from 'react';
import {
  AzureB2CService,
  AuthConsumingService,
  OIDCSigninCallback,
  OIDCSignoutCallback,
} from '@arm/ce-shared-components/components/Authentication';
import { AdsLoader } from '@arm/arm-design-system-react';
import config from '../../temp/config';
import { UseGlobalState } from '../../context/index';
import { AZUREB2CSERVICE_INIT } from '../../constants/actionTypes';
import ThemeToggle from '../../ThemeToggle';
export function getAppBaseUri() {
  return (config.REACT_APP_PUBLIC_PATH || '').replace('//', '/') + '/';
}

export function getSFaAuthConfig() {
  const baseUrl = config.REACT_APP_ORIGIN + getAppBaseUri();
  return {
    authority: config.REACT_APP_SFA_AUTHORITY,
    client_id: config.REACT_APP_SFA_CLIENT_ID,
    post_logout_redirect_uri: baseUrl + 'sign-out',
    redirect_uri: baseUrl + config.REACT_APP_AUTH_SIGN_IN_URL,
    scope: config.REACT_APP_SFA_SCOPE,
    silent_redirect_uri: baseUrl + config.REACT_APP_AUTH_SILENT_SIGN_IN_URL,
    test: config.REACT_APP_ENV,
  };
}

export const login = (props) => {

  const params = new URLSearchParams(window.location.search);
  const returnUrl = params.get('returnUrl') || '/';

  // Store returnUrl in sessionStorage for the signin callback
  sessionStorage.setItem('returnUrl', returnUrl);

  AzureB2CService.init(AuthConsumingService, null, getSFaAuthConfig(), null, '/')
    .then(() => {
      try {
        AzureB2CService.login(false, new URL(`${config.REACT_APP_ORIGIN}${returnUrl}`));
      } catch (loginError) {
        console.error('Azure B2C login failed:', loginError);
        alert('Login redirect failed: ' + (loginError.message || 'Unknown error'));
      }
    })
    .catch((error) => {
      console.error('Azure B2C initialization failed:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        config: getSFaAuthConfig()
      });
      alert('Login failed: ' + (error.message || 'Unknown error occurred'));
    });

  return (
    <ThemeToggle>
      <div className="c-dh-content u-flex-center">
          <AdsLoader isLoading />
      </div>
    </ThemeToggle>
  );
};

export const signin = (props) => {
  const { dispatch } = UseGlobalState();
  
  const signinCallback = (user) => {
    
    // Extract user information from the token/profile
    const userProfile = user.profile || {};
    
    // Dispatch user data to context
    dispatch({
      type: AZUREB2CSERVICE_INIT,
      data: { 
        isAuth: true, 
        user: {
          ...userProfile,
          token: user.access_token,
          id_token: user.id_token
        },
        isLoginDone: true 
      },
    });

    // Get the return URL from the original login request
    // Check if there's a returnUrl in sessionStorage or default to home
    const returnUrl = sessionStorage.getItem('returnUrl') || '/';
    sessionStorage.removeItem('returnUrl'); // Clean up
    
    
    // Use setTimeout to ensure the dispatch completes before redirect
    setTimeout(() => {
      window.location.href = returnUrl;
    }, 100);
    
    return Promise.resolve(user);
  };

  return (
    <ThemeToggle>
          <OIDCSigninCallback onUserLoggedIn={signinCallback} />
    </ThemeToggle>
  );
};
export const logout = () => {
  const { dispatch } = UseGlobalState();
  
  // Clear user data from context
  dispatch({ type: 'CLEAR_USER_DATA' });
  
  // Delete Coveo user token
  const coveoUserTokenName = 'coveoUserToken';
  const coveoUserToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith(coveoUserTokenName));
  if (coveoUserToken) {
    const coveoUserTokenValue = coveoUserToken.split('=')[1];
    document.cookie = `${coveoUserTokenName}=${coveoUserTokenValue}; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; secure`;
  }
  AzureB2CService.init(AuthConsumingService, null, getSFaAuthConfig(), '/').then(() => {
    AzureB2CService.logout();
  });
  return (
    <ThemeToggle>
      <div className="c-dh-content u-flex-center">
        <AdsLoader isLoading />
      </div>
    </ThemeToggle>
  );
};

export const signOutCallback = () => {
  if (window !== undefined) {
    window.location = config.REACT_APP_ORIGIN + '/';
  }
  return AzureB2CService.init(
    AuthConsumingService,
    null,
    getSFaAuthConfig(),
    getAppBaseUri(),
    true
  );
};

export const signOut = () => {
  return (
    <ThemeToggle>
      <OIDCSignoutCallback onUserLoggedOut={signOutCallback} />
    </ThemeToggle>
  );
};

export default login;
